/* KINEO — scripts propios (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.kn-reveal:not(.kn-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('kn-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('kn-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    if (reduce) return;
    var items = document.querySelectorAll('[data-kn-parallax]');
    if (!items.length) return;
    var ticking = false;
    function update() {
      items.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-kn-parallax')) || 0;
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        el.style.transform = 'translate3d(0,' + (-r.top * k / 100).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initCompare() {
    document.querySelectorAll('.kn-compare').forEach(function (box) {
      var input = box.querySelector('input[type=range]');
      if (!input || box.dataset.knReady) return;
      box.dataset.knReady = '1';
      function set() { box.style.setProperty('--kn-pos', input.value + '%'); }
      input.addEventListener('input', set);
      set();
    });
  }

  function initCountUp() {
    var nums = document.querySelectorAll('[data-kn-count]');
    if (!nums.length || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, end = parseFloat(el.getAttribute('data-kn-count')), suf = el.getAttribute('data-kn-suffix') || '';
        var t0 = null, dur = 1400;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1), v = end * (1 - Math.pow(1 - p, 3));
          el.textContent = (end % 1 ? v.toFixed(1) : Math.round(v)) + suf;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function money(cents, fmt) {
    fmt = fmt || '${{amount_no_decimals}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount_no_decimals';
    function fmtNum(n, dec, th, ds) {
      var p = (n / 100).toFixed(dec).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? ds + p[1] : '');
    }
    var v;
    switch (key) {
      case 'amount': v = fmtNum(cents, 2, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmtNum(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmtNum(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmtNum(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fmtNum(cents, 0, ' ', ''); break;
      default: v = fmtNum(cents, 0, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  function initProduct() {
    document.querySelectorAll('[data-kn-product]').forEach(function (root) {
      if (root.dataset.knReady) return;
      root.dataset.knReady = '1';
      var dataEl = root.querySelector('[data-kn-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var fmt = root.getAttribute('data-kn-money');
      var idInput = root.querySelector('input[name=id]');
      var btn = root.querySelector('[data-kn-add]');
      var btnText = btn ? btn.getAttribute('data-kn-text') : '';
      var soldText = btn ? btn.getAttribute('data-kn-sold') : '';
      var priceNow = root.querySelectorAll('[data-kn-price]');
      var priceWas = root.querySelector('[data-kn-was]');
      var save = root.querySelector('[data-kn-save]');
      var mainImg = root.querySelector('[data-kn-main-img]');

      function selected() {
        var opts = [];
        root.querySelectorAll('[data-kn-option]').forEach(function (fs) {
          var i = parseInt(fs.getAttribute('data-kn-index'), 10);
          var c = fs.querySelector('input:checked');
          opts[i] = c ? c.value : null;
          var lbl = fs.querySelector('[data-kn-selected]');
          if (lbl && c) lbl.textContent = c.nextElementSibling ? c.nextElementSibling.textContent : c.value;
        });
        return opts;
      }
      function update() {
        var opts = selected();
        var v = variants.find(function (x) {
          return x.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }) && (x.available || !variants.some(function (y) { return y.available && y.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); }));
        });
        // marcar valores sin combinación disponible
        root.querySelectorAll('[data-kn-option]').forEach(function (fs) {
          var i = parseInt(fs.getAttribute('data-kn-index'), 10);
          fs.querySelectorAll('input').forEach(function (inp) {
            var ok = variants.some(function (x) {
              return x.available && x.options[i] === inp.value && x.options.every(function (o, j) { return j === i || opts[j] == null || o === opts[j]; });
            });
            inp.nextElementSibling.classList.toggle('kn-unavailable', !ok);
          });
        });
        if (!v) { if (btn) { btn.disabled = true; btn.textContent = soldText; } return; }
        idInput.value = v.id;
        var packBox = root.querySelector('[data-kn-pack]'), qtyInput = root.querySelector('[data-kn-qty]');
        var wasOf = function (x) { return x.compare_at_price && x.compare_at_price > x.price ? x.compare_at_price : x.price; };
        var fill = function (label, now, was, n) {
          var pct = was > now ? Math.round((was - now) / was * 100) : 0;
          return label.replace('[ahorro]', money(was - now, fmt)).replace('[porcentaje]', pct + '%').replace('[por_par]', money(Math.round(now / n), fmt));
        };
        var q = 1, sel = [v], final = v.price, base = wasOf(v);
        if (packBox) {
          var pc = packBox.querySelector('input[type=radio]:checked'); q = pc ? parseInt(pc.value, 10) : 1;
          var pv = { 1: v };
          root.querySelectorAll('[data-kn-pair]').forEach(function (box) {
            var n = parseInt(box.getAttribute('data-kn-pair'), 10), ss = box.querySelectorAll('select'), o = [];
            box.hidden = q < n;
            if (!box.dataset.touched) ss.forEach(function (s) { var i = parseInt(s.getAttribute('data-kn-p-index'), 10); if (opts[i] != null) s.value = opts[i]; });
            ss.forEach(function (s) { o[parseInt(s.getAttribute('data-kn-p-index'), 10)] = s.value; });
            pv[n] = variants.find(function (x) { return x.options.every(function (val, i) { return o[i] == null || val === o[i]; }); }) || v;
          });
          var par1 = root.querySelector('[data-kn-par1]'); if (par1) par1.hidden = q < 2;
          packBox.querySelectorAll('input[type=radio]').forEach(function (inp) {
            var n = parseInt(inp.value, 10), now = -parseInt(inp.getAttribute('data-kn-desc') || '0', 10), was = 0, kd = knDeal();
            if (kd && n >= kd.min) now -= kd.off;
            for (var k = 1; k <= n; k++) { var x = pv[k] || v; now += x.price; was += wasOf(x); }
            var card = inp.closest('.kn-bundle__card');
            card.classList.toggle('is-active', inp.checked);
            var bp = card.querySelector('[data-kn-bprice]'), bw = card.querySelector('[data-kn-bwas]'), bs = card.querySelector('[data-kn-bsub]');
            if (bp) bp.textContent = money(now, fmt);
            if (bw) { bw.hidden = !(was > now); bw.textContent = money(was, fmt); }
            if (bs) bs.textContent = fill(bs.getAttribute('data-kn-label'), now, was, n);
            if (n === q) { final = now; base = was; }
          });
          sel = []; for (var k2 = 1; k2 <= q; k2++) sel.push(pv[k2] || v);
        }
        root._knSel = sel;
        var mismo = sel.every(function (x) { return x.id === v.id; });
        if (qtyInput) qtyInput.value = mismo ? q : 1;
        priceNow.forEach(function (el) { el.textContent = money(final, fmt); });
        var hasWas = base > final;
        if (priceWas) { priceWas.textContent = hasWas ? money(base, fmt) : ''; priceWas.hidden = !hasWas; }
        if (save) {
          save.hidden = !hasWas;
          if (hasWas) save.textContent = fill(save.getAttribute('data-kn-label'), final, base, q);
        }
        if (btn) { btn.disabled = !sel.every(function (x) { return x.available; }); btn.textContent = btn.disabled ? soldText : btnText; }
        if (v.image && mainImg) {
          mainImg.src = v.image;
          root.querySelectorAll('[data-kn-thumb]').forEach(function (o) { o.setAttribute('aria-current', o.getAttribute('data-kn-thumb') === v.image ? 'true' : 'false'); });
        }
        if (window.history && window.history.replaceState && root.hasAttribute('data-kn-url')) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
      }
      root.querySelectorAll('[data-kn-option] input, [data-kn-pack] input').forEach(function (inp) { inp.addEventListener('change', update); });
      var idField = root.querySelector('input[name=id]');
      root.querySelectorAll('[data-kn-pair]').forEach(function (box) { if (idField) idField.parentNode.insertBefore(box, idField); });
      root.querySelectorAll('[data-kn-pair] select').forEach(function (s) { s.addEventListener('change', function () { s.closest('[data-kn-pair]').dataset.touched = '1'; update(); }); });
      var packParam = new URLSearchParams(window.location.search).get('pack');
      if (packParam) { var pInp = root.querySelector('[data-kn-pack] input[value="' + packParam + '"]'); if (pInp) pInp.checked = true; }
      update();

      // Galería
      root.querySelectorAll('[data-kn-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          if (!mainImg) return;
          mainImg.src = t.getAttribute('data-kn-thumb');
          root.querySelectorAll('[data-kn-thumb]').forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
        });
      });

      // Añadir al carrito vía AJAX con el carrito de Dawn; si falla, envío normal del formulario
      var form = root.querySelector('form[action*="/cart/add"]');
      var err = root.querySelector('[data-kn-error]');
      if (form) {
        form.addEventListener('submit', function (ev) {
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (!cart || typeof cart.renderContents !== 'function' || !window.routes) return;
          ev.preventDefault();
          if (btn) btn.disabled = true;
          if (err) err.textContent = '';
          var sel = root._knSel || [], req, items = [];
          sel.forEach(function (x) { var it = items.find(function (i) { return i.id === x.id; }); if (it) it.quantity++; else items.push({ id: x.id, quantity: 1 }); });
          if (items.length > 1) {
            // pares distintos: varias líneas en el carrito (los descuentos de pack se aplican igual)
            req = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify({ items: items, sections: cart.getSectionsToRender().map(function (s) { return s.id; }), sections_url: window.location.pathname }) };
          } else {
            var fd = new FormData(form);
            fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
            fd.append('sections_url', window.location.pathname);
            req = { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd };
          }
          fetch(window.routes.cart_add_url, req)
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) { if (err) err.textContent = res.description || res.message; return; }
              cart.renderContents(res);
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            })
            .catch(function () { form.submit(); })
            .finally(function () { if (btn) btn.disabled = false; });
        });
      }

      // Botón fijo en móvil cuando el principal sale de pantalla
      var sticky = root.querySelector('.kn-sticky-buy');
      if (sticky && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { sticky.classList.toggle('kn-show', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(btn);
        sticky.querySelector('button').addEventListener('click', function () { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      }
    });
  }


  function initSub() {
    document.querySelectorAll("[data-kn-sub]").forEach(function (box) {
      if (box.dataset.knReady) return; box.dataset.knReady = "1";
      var form = box.querySelector("form"), msg = box.querySelector(".kn-sub__msg"), btn = form.querySelector("button");
      form.addEventListener("submit", function (ev) {
        ev.preventDefault();
        var email = form.email.value.trim();
        if (!/^[^@s]+@[^@s]+.[^@s]+$/.test(email)) { msg.textContent = msg.getAttribute("data-err"); return; }
        btn.disabled = true;
        fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(box.getAttribute("data-company")), {
          method: "POST", headers: { "content-type": "application/vnd.api+json", revision: "2026-07-15" },
          body: JSON.stringify({ data: { type: "subscription", attributes: { custom_source: "Web KINEO – Suscripción", profile: { data: { type: "profile", attributes: { email: email, subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } } } } }, relationships: { list: { data: { type: "list", id: box.getAttribute("data-list") } } } } })
        }).then(function (r) {
          if (r.ok || r.status === 202) { msg.textContent = msg.getAttribute("data-ok"); form.reset(); }
          else { msg.textContent = msg.getAttribute("data-err"); }
        }).catch(function () { msg.textContent = msg.getAttribute("data-err"); }).finally(function () { btn.disabled = false; });
      });
    });
  }

  // Precio aproximado en moneda local (referencia). Se cobra siempre en US$.
  var KN_EUR = 'AT BE BG CY DE EE ES FI FR GR HR IE IT LT LU LV MT NL PT SI SK'.split(' ');
  var KN_CUR = { MX: 'MXN', CL: 'CLP', CO: 'COP', PE: 'PEN', AR: 'ARS', CR: 'CRC', GT: 'GTQ', HN: 'HNL', NI: 'NIO', PY: 'PYG', UY: 'UYU', BO: 'BOB', BR: 'BRL', DO: 'DOP', CA: 'CAD', GB: 'GBP', CH: 'CHF', NO: 'NOK', SE: 'SEK', DK: 'DKK', PL: 'PLN', CZ: 'CZK', HU: 'HUF', RO: 'RON', IS: 'ISK', AU: 'AUD', NZ: 'NZD', JP: 'JPY', KR: 'KRW', SG: 'SGD', HK: 'HKD', MY: 'MYR', IL: 'ILS', AE: 'AED' };
  function knStore(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k) || 'null'); sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function knCountry() {
    var c = knStore('kn_country');
    if (c) return Promise.resolve(c);
    return fetch('/browsing_context_suggestions.json').then(function (r) { return r.json(); }).then(function (d) {
      var h = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
      if (h) knStore('kn_country', h);
      return h || (window.Shopify && Shopify.country) || null;
    }).catch(function () { return (window.Shopify && Shopify.country) || null; });
  }
  function knRates() {
    var c = knStore('kn_rates');
    if (c && Date.now() - c.t < 12 * 3600 * 1000) return Promise.resolve(c.r);
    return fetch('https://open.er-api.com/v6/latest/USD').then(function (r) { return r.json(); }).then(function (d) {
      if (!d || d.result !== 'success') return null;
      knStore('kn_rates', { t: Date.now(), r: d.rates });
      return d.rates;
    }).catch(function () { return null; });
  }
  function initFx() {
    var box = document.querySelector('[data-kn-fx]');
    if (!box || box.dataset.knReady) return;
    box.dataset.knReady = '1';
    Promise.all([knCountry(), knRates()]).then(function (res) {
      var cc = res[0], rates = res[1];
      var cur = cc && (KN_EUR.indexOf(cc) >= 0 ? 'EUR' : KN_CUR[cc]);
      if (!cur || !rates || !rates[cur]) return;
      var rate = rates[cur], aprox = box.getAttribute('data-aprox') || '';
      var lang = document.documentElement.lang || 'es';
      var usd = function (el) { var n = parseFloat((el.textContent || '').replace(/[^0-9.]/g, '')); return isNaN(n) ? null : n; };
      var fmt = function (n) {
        var v = n * rate, dec = v >= 1000 ? 0 : (v >= 100 ? 0 : 2);
        try { return new Intl.NumberFormat(lang, { maximumFractionDigits: dec, minimumFractionDigits: dec }).format(v) + ' ' + cur; } catch (e) { return Math.round(v) + ' ' + cur; }
      };
      var main = box.querySelector('[data-kn-fx-main]'), price = document.querySelector('[data-kn-price]');
      var render = function () {
        var p = price && usd(price);
        if (p) { main.textContent = '≈ ' + fmt(p) + ' ' + aprox; box.hidden = false; }
        document.querySelectorAll('[data-kn-fx-card]').forEach(function (el) {
          var b = el.parentNode.querySelector('[data-kn-bprice]'), v = b && usd(b);
          if (v) { el.textContent = '≈ ' + fmt(v); el.hidden = false; }
        });
      };
      render();
      if ('MutationObserver' in window) {
        var mo = new MutationObserver(render);
        document.querySelectorAll('[data-kn-price], [data-kn-bprice]').forEach(function (el) { mo.observe(el, { childList: true, characterData: true, subtree: true }); });
      }
    });
  }

  // Oferta del día: ventana vigente del calendario (snippet kn-ofertas-data)
  function knDeal() {
    var el = document.getElementById('kn-ofertas');
    if (!el) return null;
    try {
      var d = JSON.parse(el.textContent), now = Date.now();
      for (var i = 0; i < d.ventanas.length; i++) {
        var v = d.ventanas[i];
        if (now >= v.s && now <= v.e) return { t: v.t, e: v.e, min: d.tipos[v.t].min, off: d.tipos[v.t].off, dias: Math.floor((v.e - v.s) / 864e5) };
      }
    } catch (e) {}
    return null;
  }
  function initDayDeal() {
    var box = document.querySelector('[data-kn-daydeal]');
    if (!box || box.dataset.knReady) return;
    box.dataset.knReady = '1';
    var deal = knDeal();
    if (!deal) return;
    var card = document.querySelector('[data-kn-pack] input[value="' + deal.min + '"]');
    card = card && card.closest('.kn-bundle__card');
    var bp = card && card.querySelector('[data-kn-bprice]');
    var precio = bp ? bp.textContent.trim() : '';
    var pre = box.getAttribute(deal.dias >= 1 ? 'data-especial' : 'data-hoy') || '';
    box.querySelector('[data-kn-dd-title]').textContent = pre + ' ' + (box.getAttribute('data-' + deal.t) || '').replace('[precio]', precio);
    if (card) card.classList.add('kn-bundle__card--deal');
    var el = {};
    ['d', 'h', 'm', 's'].forEach(function (k) { el[k] = box.querySelector('[data-kn-cd="' + k + '"]'); });
    var daysBox = box.querySelector('[data-kn-dd-days]');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var left = Math.floor((deal.e - Date.now()) / 1000);
      if (left <= 0) { clearInterval(t); location.reload(); return; }
      var d = Math.floor(left / 86400);
      el.d.textContent = d; if (daysBox) daysBox.hidden = d < 1;
      el.h.textContent = pad(Math.floor(left % 86400 / 3600));
      el.m.textContent = pad(Math.floor(left % 3600 / 60));
      el.s.textContent = pad(left % 60);
      box.hidden = false;
    };
    var t = setInterval(tick, 1000);
    tick();
  }

  // Contador hasta una fecha fija; al terminar se oculta (no se reinicia)
  function initCountdown() {
    document.querySelectorAll('[data-kn-countdown]').forEach(function (box) {
      if (box.dataset.knReady) return;
      box.dataset.knReady = '1';
      var end = Date.parse(box.getAttribute('data-end'));
      if (isNaN(end)) return;
      var el = {};
      ['d', 'h', 'm', 's'].forEach(function (k) { el[k] = box.querySelector('[data-kn-cd="' + k + '"]'); });
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) { box.hidden = true; clearInterval(t); return; }
        el.d.textContent = Math.floor(left / 86400);
        el.h.textContent = pad(Math.floor(left % 86400 / 3600));
        el.m.textContent = pad(Math.floor(left % 3600 / 60));
        el.s.textContent = pad(left % 60);
        box.hidden = false;
      };
      var t = setInterval(tick, 1000);
      tick();
    });
  }

  function initAll() { initReveal(); initParallax(); initCompare(); initCountUp(); initProduct(); initSub(); initFx(); initCountdown(); initDayDeal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
